import $ from 'jquery';

$(function() {

    // Adds samples to an order for the product just added
    $('.js-samples-add').on('click', function(e) {
        
        $.ajax({
            url: '/wp-admin/admin-ajax.php',
            method: 'POST',
            data: {
                action: 'mt_add_samples_to_order',
                productKey: $(this).data('key'),
            },
            success: function(response) {
                if (response.success) {
                    window.location = response.url;
                }
            }
        })

    });

    // Closes the add samples modal
    $('.js-samples-close').on('click', function(e) {
        $('.sample-overlay').removeClass('active');
    });

    // Removes a sample from the cart
    $('.js-samples-remove').on('click', function(e) {
        $.ajax({
            url: '/wp-admin/admin-ajax.php',
            method: 'POST',
            data: {
                action: 'mt_remove_samples_from_order',
                productId: $(this).data('product-id'),
            },
            success: function(response) {
                if (response.success) {
                    window.location = response.url;
                }
            }
        })
    });

    // Checks the fleck checkbox has been checked before checking out.
    $(document).on('change', '#fleckAck', function(e) {
        const $checkoutBtn = $('.js-checkout');
        if ($(this).is(':checked')) {
            $checkoutBtn.removeAttr('disabled');
            $checkoutBtn.removeClass('btn-disabled');
        } else {
            $checkoutBtn.attr('disabled', 'disabled');
            $checkoutBtn.addClass('btn-disabled');
        }
    });

});